import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '../../hooks/useFeatureFlags';

interface OverviewOrStagesProps {
  overviewComponent: React.ComponentType;
  stagesComponent: React.ComponentType;
  redirectPath?: string;
}

export const OverviewOrStages: React.FC<OverviewOrStagesProps> = ({
  overviewComponent: OverviewComponent,
  stagesComponent: StagesComponent,
  redirectPath,
}) => {
  const { isEnabled, isLoading } = useFeatureFlag('module_overview_analytics');

  // Пока флаг загружается — ничего не рендерим (данные придут из кэша мгновенно).
  if (isLoading) return null;

  if (isEnabled) {
    return <OverviewComponent />;
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return <StagesComponent />;
};

export default OverviewOrStages;
